import { AbstractDialogContent } from '@abstracts/dialog/dialog-content';
import { Component, Injector, Input, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { ChargingStation } from '@models/charging-station';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AuthenticationService } from '@services/authentication/authentication.service';
import { FormService } from '@services/form/form.service';

@Component({
  selector: 'app-change-password-success-dialog-content',
  templateUrl: './change-password-success-dialog-content.component.html',
  styleUrls: ['./change-password-success-dialog-content.component.scss']
})
export class ChangePasswordSuccessContentComponent extends AbstractDialogContent implements OnInit {

  public className = 'ChangePasswordSuccessContentComponent';

  public form: UntypedFormGroup;


  constructor(
    public activeModal: NgbActiveModal,
    public formService: FormService,
    injector: Injector) {
    super(activeModal, injector);
  }

  ngOnInit(): void {
    super.ngOnInit();

    this.formService.form = new UntypedFormGroup({
    });
  }

  onSubmit(formValue) {
    this.authenticationService.logout();
    this.router.navigate(["logout-callback"]);
    this.activeModal.close();
  }

}
